// extracted by css-extract-rspack-plugin
export default {"cls1":"StatelessWorkCardsUpsellModal-styles-cls1_CQQ","cls2":"StatelessWorkCardsUpsellModal-styles-cls2_hg1 StatelessWorkCardsUpsellModal-styles-cls1_CQQ"};